/**
 * Textos fixos do chat de triagem. Edite aqui; nada disso é gerado pela IA.
 * Os marcados com [REVISAR] dependem de aprovação da Sun Coast.
 */

/** R$ sem centavos e com espaço comum (o pt-BR usa espaço não separável, que atrapalha busca e WhatsApp). */
export const brl0 = (n: number) =>
  n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).replace(/\u00a0/g, ' ');

export const TEXTOS = {
  abertura:
    'Olá! Sou o assistente virtual da Sun Coast Energia Solar. Em poucas perguntas eu entendo o seu projeto e passo você para um consultor no WhatsApp. É gratuito e sem compromisso.',

  perguntas: {
    objetivo: 'Como posso ajudar você hoje?',
    imovel: 'Onde você quer instalar a energia solar?',
    aptoArea: 'No apartamento, você tem uma área própria para os painéis, como uma cobertura ou laje só sua?',
    conta: 'Qual é o valor médio da sua conta de luz por mês? Escolha uma faixa ou digite o valor.',
    contaValor: 'Qual é o valor aproximado da conta por mês? Pode digitar só o número, por exemplo: 3500.',
    cep: 'Qual é o CEP do local da instalação?',
    cepManutencao: 'Qual é o CEP do local onde o sistema está instalado?',
    cidade: 'Sem problema. Em qual cidade fica o imóvel?',
    propriedade: 'O imóvel é seu?',
    local: 'Onde os painéis ficariam?',
    pagamento: 'Você pensa em pagar à vista ou financiar? Temos financiamento em até 96 vezes.',
    prazo: 'E para quando você pensa em instalar?',
    manutencao: 'Conte em poucas palavras o que está acontecendo com o seu sistema.',
    naoEntendi: 'Não consegui entender. Escolha uma das opções abaixo, por favor.',
    repetirValor: 'Não consegui entender o valor. Pode escrever só o número? Por exemplo: 450.',
    cepInvalido: 'Esse CEP parece incompleto. Pode digitar os 8 números? Se não souber, toque em "Não sei o CEP".',
    manutencaoCurta: 'Pode contar um pouco mais? Por exemplo: "o inversor está apitando" ou "a geração caiu".',
  },

  voltou: 'Tudo bem, voltamos um passo.',
  encerrou: 'Tudo bem, encerramos por aqui. Se quiser retomar, é só voltar quando quiser.',
  arquivo:
    'Por aqui eu ainda não recebo arquivos. Se quiser mandar a conta de luz, envie direto para o consultor no WhatsApp, no fim da conversa. Vamos continuar?',
  pulouOpcional: 'Tudo bem, seguimos sem essa informação.',
  ajuda: 'Se estiver difícil agora, você pode tocar em "Encerrar conversa" e voltar depois.',

  /** Encerramentos de quem não segue para o WhatsApp. A conversa termina aqui (decisão da Sun Coast). */
  foraDoPerfil: {
    conta_baixa: (minimo: number) =>
      `Obrigado pelas informações! Com uma conta abaixo de ${brl0(minimo)} por mês, a energia solar ainda não costuma compensar o investimento, então não vamos seguir com o orçamento agora. Se o seu consumo aumentar, é só voltar aqui.`,
    apartamento_sem_area:
      'Obrigado! Sem uma área própria no prédio, não é possível instalar painéis só para o seu apartamento. Se o condomínio tiver interesse em um projeto para as áreas comuns, é só voltar e escolher "Condomínio".',
    fora_da_area:
      'Obrigado! No momento atendemos o estado de São Paulo e, fora dele, só projetos de maior porte. Por isso não conseguimos seguir com o seu atendimento agora.',
  },

  qualificado:
    'Perfeito, já tenho o que preciso! Preencha seus dados abaixo para um consultor da Sun Coast continuar o atendimento pelo WhatsApp.',
  analiseIntro: 'Pronto! Com base nas suas respostas, fiz uma pré-análise do seu projeto:',
  analiseAviso:
    'Estimativa feita com o valor da sua conta e a média de sol em São Paulo. O consultor confirma os números com a sua conta de luz e uma visita técnica.',
  analiseSobMedida: 'Para indústrias e contas muito altas o projeto é sob medida: o consultor pode indicar outra solução.',
  qualificadoComAnalise:
    'Quer o orçamento exato? Confira o resumo e preencha seus dados para um consultor da Sun Coast continuar pelo WhatsApp.',
  qualificadoManutencao:
    'Entendi. Preencha seus dados abaixo para a nossa equipe técnica falar com você pelo WhatsApp.',

  /** [REVISAR] Consentimento exibido no formulário. O servidor grava exatamente o texto mostrado. */
  consentimento:
    'Autorizo a Sun Coast Energia Solar a usar meu nome, WhatsApp, e-mail e as respostas desta conversa para entrar em contato comigo sobre o meu atendimento.',
  transparencia:
    'O valor do sistema e as condições de pagamento são definidos pelo consultor depois da análise da sua conta de luz.',
  botaoWhatsapp: 'Continuar no WhatsApp',
} as const;

export const CHIPS = {
  sim: { valor: 'sim', rotulo: 'Sim' },
  nao: { valor: 'nao', rotulo: 'Não' },
  pular: { valor: 'pular', rotulo: 'Pular' },
  naoSeiCep: { valor: 'pular', rotulo: 'Não sei o CEP' },
  naoDizer: { valor: 'pular', rotulo: 'Prefiro não dizer' },
} as const;
